import { Component, OnInit, HostListener, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Breakpoints, BreakpointObserver } from '@angular/cdk/layout';
import { map, shareReplay } from 'rxjs/operators';
import { ValueHelperService } from './business-ledger/services/value-helper.service';
import { environment } from '../environments/environment';
import {
    Router,
    ActivatedRoute,
    NavigationStart,
    NavigationEnd,
} from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { ProfileService } from './profile/services/profile.service';
import { InstrumentationService } from './@core/services/instrumentation/instrumentation.service';
import { RouteTrackingService } from './@core/services/router-tracking/route-tracking.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
    private scrollTimeout: any;
    title = 'seller-portal';
    public sellerDetails: any;
    isHandset$: Observable<boolean> = this.breakpointObserver
        .observe(Breakpoints.Handset)
        .pipe(
            map((result) => result.matches),
            shareReplay()
        );

    constructor(
        private breakpointObserver: BreakpointObserver,
        private valueHelperService: ValueHelperService,
        private router: Router,
        private activatedRouter: ActivatedRoute,
        private profileService: ProfileService,
        private instrumentationService: InstrumentationService,
        private routeTrackingService: RouteTrackingService,
        @Inject(DOCUMENT) private doc: any
    ) {
        //  this.setAnalyticsTrackerScript();
        valueHelperService.loadRouting();
        // this.router.events.subscribe((event) => {
        //     if (event instanceof NavigationEnd) {
        //         this.instrumentationService.logEvent('page_view', {
        //             url: event.urlAfterRedirects,
        //         });
        //     }
        // });
    }

    @HostListener('document:click', ['$event'])
    onDocumentClick(event: MouseEvent) {
        const target = event.target as HTMLElement;
        // this.instrumentationService.logEvent('click', {
        //     tag: target.tagName,
        //     id: target.id,
        //     class: target.className,
        //     text: target.textContent?.trim().slice(0, 50), // limit text length
        // });
    }

    @HostListener('window:scroll', [])
    onWindowScroll() {
        clearTimeout(this.scrollTimeout);
        // this.scrollTimeout = setTimeout(() => {
        //     this.instrumentationService.logEvent('scroll', {
        //         scrollY: window.scrollY,
        //         scrollX: window.scrollX,
        //     });
        // }, 300); // Debounce delay: 300ms
    }

    ngOnInit() {
        let count = 0;
        this.getSellerDetails();
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                let analyticsId = sessionStorage.getItem('analyticsId');
                const isSellerDetailsExist =
                    sessionStorage.getItem('sellerDetails');
                if (isSellerDetailsExist) {
                    const sellerDetails =
                        typeof isSellerDetailsExist === 'string'
                            ? JSON.parse(isSellerDetailsExist)
                            : isSellerDetailsExist;
                    (window as any).Moengage.add_first_name(
                        sellerDetails?.companyName
                    );
                    (window as any).Moengage.add_email(
                        sellerDetails?.companyEmailId || ''
                    );
                    (window as any).Moengage.add_mobile(
                        sellerDetails?.user[0]?.mobileNumber || ''
                    );
                    (window as any).Moengage.add_user_name(
                        sellerDetails.companyName || ''
                    );
                    (window as any).Moengage.add_user_attribute('seller', true);
                    (window as any).Moengage.add_user_attribute(
                        'platform_type',
                        'SELLER_PORTAL'
                    );
                    this.trackSellerCategoryAttribute();
                }
                if (analyticsId) {
                    (window as any).Moengage.add_unique_user_id(analyticsId);
                }
                if (count == 0) {
                    // do nothing
                } else {
                    window['_paq'].push(['setCustomUrl', window.location.href]);
                    window['_paq'].push(['setDocumentTitle', 'Seller Portal']);
                    window['_paq'].push(['trackPageView']);
                }
                count++;

                // console.log(event.url, event.url.includes('/dashboard/profile/'))
                if (event.url.includes('/dashboard/profile/')) {
                    (<any>window).fcWidget?.hide();
                } else {
                    let _this = this;
                    setTimeout(function () {
                        const isSellerDetailsExist =
                            sessionStorage.getItem('sellerDetails');
                        if (isSellerDetailsExist) {
                            const sellerDetails =
                                typeof isSellerDetailsExist === 'string'
                                    ? JSON.parse(isSellerDetailsExist)
                                    : isSellerDetailsExist;
                            (<any>window).fcWidget.init({
                                token: '07908da8-c88f-4810-b070-b024ddea5fd9',
                                host: 'https://solv2.freshchat.com',
                                externalId: sellerDetails?.companyEmailId,
                                restoreId: sessionStorage.getItem(
                                    'freshChatRestoreId'
                                )
                                    ? sessionStorage.getItem(
                                          'freshChatRestoreId'
                                      )
                                    : null,
                            });
                            (<any>window).fcWidget.user.get(function (resp) {
                                var status = resp && resp.status,
                                    data = resp && resp.data;
                                // console.log(resp, 1);
                                if (status !== 200) {
                                    (<any>window).fcWidget.user.setProperties({
                                        firstName: sellerDetails?.companyName,
                                        email: sellerDetails?.companyEmailId,
                                        phone: sellerDetails?.companyNumber,
                                    });
                                    (<any>window).fcWidget.on(
                                        'user:created',
                                        function (resp) {
                                            var status = resp && resp.status,
                                                data = resp && resp.data;
                                            // console.log(resp, 2);
                                            if (status === 200) {
                                                if (data.restoreId) {
                                                    // Update restoreId in your database
                                                    _this.profileService
                                                        .saveFreshChatRestoreId(
                                                            data.restoreId
                                                        )
                                                        .subscribe(
                                                            (res: any) => {
                                                                // console.log(res)
                                                                sessionStorage.setItem(
                                                                    'freshChatRestoreId',
                                                                    res?.data
                                                                        ?.restoreId
                                                                );
                                                            },
                                                            (error) => {
                                                                console.log(
                                                                    error
                                                                );
                                                                this.enableSpinner$.next(
                                                                    false
                                                                );
                                                                this.toasterService.error(
                                                                    'Unable to save the Fresh Chat RestoreId.'
                                                                );
                                                            }
                                                        );
                                                }
                                            }
                                        }
                                    );
                                }
                            });
                            (<any>window).fcWidget?.show();
                        } else {
                            (<any>window).fcWidget.init({
                                token: '07908da8-c88f-4810-b070-b024ddea5fd9',
                                host: 'https://solv2.freshchat.com',
                            });
                            (<any>window).fcWidget?.show();
                            (<any>window).fcWidget?.user
                                .get()
                                .then(function (result) {
                                    // console.log(result);
                                    var userInfo = result.data;
                                    if (userInfo.email || userInfo.phone) {
                                        (<any>window).fcWidget.user
                                            .clear()
                                            .then(function () {
                                                console.log('User cleared');
                                            });
                                    }
                                });
                        }
                    }, 2000);
                }
            }
        });
    }

    getSellerDetails() {
        this.sellerDetails = sessionStorage.getItem('sellerDetails');
        this.sellerDetails =
            typeof this.sellerDetails === 'string'
                ? JSON.parse(sessionStorage.getItem('sellerDetails'))
                : this.sellerDetails;
    }

    trackSellerCategoryAttribute() {
        this.profileService.getSellerProfileDetails().subscribe(
            (response: any) => {
                if (response && response.data && response.data.sme) {
                    (window as any).Moengage.add_user_attribute(
                        'category',
                        response.data.sme.sellWishList[0]
                    );
                    (window as any).Moengage.add_user_attribute(
                        'value_chain',
                        response.data.sme.businessType
                    );
                    this.trackSellerCategoryNameAttribute(
                        response.data.sme.sellWishList[0]
                    );
                }
            },
            (error) => {
                // error handling
            }
        );
    }

    trackSellerCategoryNameAttribute(categoryId) {
        if (categoryId) {
            this.profileService.getAllBusinessCategory().subscribe(
                (response: any) => {
                    if (response && response.data && response.data.children) {
                        response.data.children.forEach((category) => {
                            if (category.id === categoryId) {
                                (window as any).Moengage.add_user_attribute(
                                    'business_category',
                                    category.title
                                );
                            }
                        });
                    }
                },
                (error) => {
                    // error hadling
                }
            );
        }
    }
}
